import React, { useState, useEffect, useContext, memo } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { getDepartments } from "@/apisParticipantPublic"
import FreeSoloCreateOptionOnDepartment from "@/components/invitation/FreeSoloCreateOptionOnDepartment"
import InvitationContext from "@/components/invitation/InvitationContext"

const Department = memo((props) => {
    const { participant, handleUpdateParticipant, setParticipantDetailError, setParticipantRoleSettingError } = props
    const { participantDetail } = useContext(InvitationContext)
    const [departments, setDepartments] = useState([])
    const [departmentLoading, setDepartmentLoading] = useState({
        loading: true,
        error: false,
        message: "",
    })
    const handleDepartmentChange = (departmentId) => {
        handleUpdateParticipant("departmentId", departmentId)
        setParticipantRoleSettingError({
            show: false,
            message: "",
        })
    }

    let componentMounted = true
    useEffect(() => {
        const getDepartmentsFunc = async (companyId) => {
            try {
                const resultDepartmentsData = await getDepartments(companyId)
                const resultDepartments = resultDepartmentsData.data.departments
                if (componentMounted) {
                    setDepartments(resultDepartments)
                    setDepartmentLoading({
                        loading: false,
                        error: false,
                        message: null,
                    })
                }
            } catch (error) {
                setDepartmentLoading({
                    loading: false,
                    error: true,
                    message: "error",
                })
                setParticipantDetailError({ status: true, message: "setting loading wrong", update: false })
            }
        }
        if (participantDetail.projects.companyId) {
            getDepartmentsFunc(participantDetail.projects.companyId)
        } else {
            setDepartmentLoading({
                loading: false,
                error: false,
                message: null,
            })
        }
        return () => {
            componentMounted = false
        }
    }, [participantDetail.projects.companyId])

    return (
        <Box mt={6}>
            {departmentLoading.loading ? (
                <Box>
                    <Typography>Loading departments... </Typography>
                </Box>
            ) : (
                <>
                    {participant.roleId ? (
                        <>
                            <Box>
                                <Typography variant="h6" component="h2" style={{ color: "black" }}>
                                    Please Select Your Department
                                </Typography>
                            </Box>
                            <Box>
                                <FreeSoloCreateOptionOnDepartment
                                    departments={departments}
                                    roleId={participant.roleId}
                                    handleDepartmentChange={handleDepartmentChange}
                                    companyId={participantDetail.projects.companyId}
                                />
                            </Box>
                        </>
                    ) : null}
                </>
            )}
        </Box>
    )
})
export default Department
